import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { post } from '../../http';

export interface IEnrollmentPayload {
  partner?: { name: string; tokenKey: string };
}

export const linkPartner = async (rewardsNumber: string, requestBody: string) => {
  try {
    const result = await post(`/guest/partner/${rewardsNumber}`, {
      body: requestBody,
    });

    evaluateResponseErrorCode(result.response);

    return result.response;
  } catch (error) {
    throw getApiError(error);
  }
};
